import { connect } from 'react-redux';

import { IAgentSchema, IOfferSchema, IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { toggle } from '../../../store/popups/callback';
import { IMakeRequest } from '../../../utils/make_request';
import { PopupCallback } from './index';
import { getCallBackContent } from '../../../selectors/experiments';
import { ICallbackContent } from './types';

export interface IPopupCallbackStoreProps {
  opener: 'agent' | 'floating' | undefined;
  agent: IAgentSchema | null;
  phones: IPhoneSchema[] | null;
  offer: IOfferSchema;
  isOpen: boolean;
  makeRequest: IMakeRequest;
  callbackContent: ICallbackContent;
  host: string;
  useOldWidget?: boolean;
}

export interface IPopupCallbackDispatchProps {
  toggle(isOpen?: boolean): void;
}

export type IPopupCallbackProps = IPopupCallbackStoreProps & IPopupCallbackDispatchProps;

function mapStateToProps(state: IState): Partial<IPopupCallbackStoreProps> {
  const callbackContent = getCallBackContent(state);

  return {
    agent: state.offerData.agent,
    isOpen: state.popupCallback.isOpen,
    offer: state.offerData.offer,
    opener: state.popupCallback.opener,
    phones: state.offerData.offer.phones,
    callbackContent,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IPopupCallbackDispatchProps {
  return {
    toggle: (isOpen?: boolean) => dispatch(toggle(undefined, isOpen)),
  };
}

export const PopupCallbackContainer = connect<
  Partial<IPopupCallbackStoreProps>,
  IPopupCallbackDispatchProps,
  Partial<IPopupCallbackStoreProps>
>(
  mapStateToProps,
  mapDispatchToProps,
)(PopupCallback);
